import {
  GridMixedColumnOption,
  GridMixedQuestionConfig,
  GridMixedQuestionSettings,
} from '@hyper-inferno/grid-mixed-core';
import {
  QuestionHandler,
  ITransformationContext,
  UniversalPiping,
} from '@hyper-inferno/survey-bot-core';
import {
  Element,
  ElementType,
  SurveyElement,
  SurveyListOption,
} from '@hyper-inferno/survey-elements-core';
import { ComposedElementBuilder } from '@hyper-inferno/survey-elements-core-utils';

interface GridMixedElementBundle extends Element {
  config: GridMixedQuestionSettings;
}

export class GridMixedHandler
  implements QuestionHandler<GridMixedQuestionConfig> {
  async buildConfig(
    el: GridMixedElementBundle,
    ctx: ITransformationContext,
  ): Promise<GridMixedQuestionConfig> {
    const rows = await ctx.listBuilding.getOptionsByListId(
      el.config.row_list_id,
      ctx,
      el.config.row_list_randomize_options,
    );

    const cols = await ctx.listBuilding.getOptionsByListId(
      el.config.column_list_id,
      ctx,
      el.config.column_list_randomize_options,
    );

    const columnConfig = el.config.column_config || [];


    const columns: GridMixedColumnOption[] = await Promise.all(
      cols.filter((col) => col.id).map(async (col) => {

        const colConfig = columnConfig.find((cc) => cc.option_id === col.id);

        if (!colConfig) {
          console.error('Missing Mixed Grid Conf');
          throw Error('Missing Mixed Grid Conf');
        }

        const element = await this.composeElement(
          colConfig.element,
          0,
          ctx,
          rows,
        );

        return {
          ...col,
          element,
        };
      }),
    );

    return {
      ...el.config,
      rows,
      columns,
    };
  }

  async composeElement(
    el: SurveyElement,
    page_id: number,
    context: ITransformationContext,
    rows: SurveyListOption[],
  ) {
    const handler = context.handlers[el.type];
    // Get current language from session
    const lang = context.session.survey_language;

    // Select the translation using the helperIO
    // const question_text = el.translations?.['question_text']?.[lang]
    //   ? pickTextFromCodex(el.translations, 'question_text', lang)
    //   : el.question_text;
    // 1. Build the base element properties
    const question_text = '';
    const elementBuilder = new ComposedElementBuilder({
      name: el.name,
      type: el.type,
      question_text: new UniversalPiping().transform(question_text, context),
      id: el.id,
      is_skippable: !el.required,
      element_type: ElementType.QUESTION_ELEMENT,
      page_id,
      rank: el.rank,
      required: el.required ?? true,
    });

    // 2. Use Handler to build the complex config
    if (handler) {
      const config = await handler.buildConfig(el, context);
      elementBuilder.setQuestionConfig(config);
    }

    rows.forEach((row) => {
      elementBuilder.setRowAnswerObject(
        row.option_key,
        context.session.jsn_responses[`r${row.option_key}_` + String(el.id)] ??
        {},
      );
    });

    // elementBuilder.setAnswerObject(
    //   context.session.jsn_responses[String(el.id)] ?? {},
    // );

    // const conditonalDisplay = context.bundle.getConditionSetsByElementId(
    //   String(el.id),
    // );

    // if (conditonalDisplay) {
    //   const composedConditionSet = this.buildComposedLogic(
    //     conditonalDisplay,
    //     context,
    //   );
    //   elementBuilder.addConditionalDisplayMeta(composedConditionSet);
    // }

    // const elementPlugins = context.bundle.getPluginsByElementId(
    //   el.id,
    //   context.session.jsn_responses ?? {},
    // );
    // elementBuilder.setElementPlugins(elementPlugins);

    return elementBuilder.build();
  }
}
